import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <p>&copy; 2025 Sacco Auto Detailing. Tous droits réservés.</p>
        </footer>
    );
};

export default Footer;